<template>
  <div v-if="productData">
    <section class="card-wrapper">
      <div class="go-back">
        <img src="~img/Shape.png" class="go-back-icon" @click="goBack" role="go back" />
        {{ $t('back') }}
      </div>
      <div class="bao-border"></div>
      <div class="content-wrapper">
        <div class="left">
          <!-- 轮播图及收藏按钮 -->
          <div class="carousel-wrapper">
            <div class="home-page-carousel">
              <Swiper
                class="swiper"
                :modules="modules"
                :space-between="10"
                :loop="productData.imageUrl && productData.imageUrl.length > 1"
                :autoplay="{ delay: 10000, disableOnInteraction: false }"
                :pagination="{
                  el: '.swiper-pagination',
                  clickable: true,
                  bulletClass: 'swiper-pagination-bullet-custom',
                  bulletActiveClass: 'swiper-pagination-bullet-active-custom',
                }"
                :navigation="{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                  addIcons: false,
                }"
                @slideChangeTransitionEnd="onSlideChangeTransitionEnd"
              >
                <SwiperSlide
                  class="swiper-slide"
                  v-for="(item, index) in productData.imageUrl"
                  :key="index"
                >
                  <img class="swiper-img" :src="item" alt="banners" @error="onImgError" />
                </SwiperSlide>
                <div v-show="productData.imageUrl.length > 1" class="swiper-pagination"></div>
                <div class="swiper-button-prev" style="display: none"></div>
                <div v-show="productData.imageUrl.length > 1" class="swiper-button-next"></div>
              </Swiper>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="right-wrapper">
            <h2 class="welcome">{{ productData.name }}</h2>
            <h2 class="title" v-if="productData.expiredDate && productData.kind === 1">
              {{ $t('expire-on') }} {{ productData.expiredDate }}
            </h2>
            <h3 class="location">{{ productData.venueName }}</h3>
            <h3 class="description">{{ productData.description }}</h3>
            <div class="btn-wrapper" v-if="productData.type">
              <button class="membership-btn" @click="goToExtrenalUrl">
                {{ productData.type }}
              </button>
            </div>
            <h4 class="detail" v-html="productData.details"></h4>
            <h5 class="terms">{{ $t('Terms-and-Conditions') }}</h5>
            <h6 class="conditions" v-html="productData.conditions"></h6>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { Autoplay, Pagination, Navigation } from 'swiper/modules';
  import 'swiper/css';
  import 'swiper/css/pagination';
  import 'swiper/css/navigation';
  // import '@/assets/css/swiper.css';
  import '@/assets/css/swiper.css';
  import { mapState } from 'vuex';
  import { httpString, removedDot } from '@/utils';

  const defaultImg = require('@/assets/images/defaultLounge.png');

  export default {
    name: 'index',
    components: {
      Swiper,
      SwiperSlide,
    },
    props: {
      typeData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        data: null,
        swiperSlideList: [],
        modules: [Autoplay, Pagination, Navigation],
        benefitInfo: null,
        productData: {
          details: '',
          conditions: '',
          imageUrl: [],
          name: '',
          expiredDate: '',
          externalUrl: '',
        },
      };
    },
    mounted() {
      this.getProductInfo();
    },
    methods: {
      onSlideChangeTransitionEnd(swiper) {
        if (swiper.isEnd) {
          swiper.navigation.nextEl.style.display = 'none';
        } else {
          swiper.navigation.nextEl.style.display = 'block';
        }
        if (swiper.isBeginning) {
          swiper.navigation.prevEl.style.display = 'none';
        } else {
          swiper.navigation.prevEl.style.display = 'block';
        }
      },
      // productDataConditionsReplace(text) {
      //   return text.replace(
      //     /*eslint-disable*/
      //     /((?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$)/,
      //     '<a href="$1">$1</a>',
      //   );
      // },
      // 获取benefit, offer详细信息
      getProductInfo() {
        const { userId, sessionId } = this.userInfo;
        const data = {
          lang: this.$i18n.locale,
          vmorcId: this.typeData.vmorcId,
          userId,
          sessionId,
        };
        this.$http.lounge
          .getOfferBenefitDetails(data)
          .then(res => {
            this.benefitInfo = res?.payload;
            // this.$set(this.productData, 'details', this.benefitInfo.details)
            // this.$set(this.productData, 'conditions', this.benefitInfo.conditions)
          })
          .catch(err => {
            console.log(err);
          });
      },
      goBack() {
        this.$router.go(-1);
      },
      goToExtrenalUrl() {
        window.open(this.productData.externalUrl);
      },
      onImgError(e) {
        const img = e.srcElement;
        img.src = defaultImg;
        img.onerror = null;
      },
    },
    computed: {
      ...mapState(['userInfo', 'isLogin']),
    },
    watch: {
      // 将benefit数据赋值给productData
      benefitInfo: {
        handler(newVal) {
          this.productData = newVal;
          this.productData.details = this.productData.details.replace(/\n/g, '<br/>');
          const conditions = this.productData.conditions.replace(/\n/g, '<br/>');
          const urls = httpString(conditions);

          if (urls && urls.length > 0) {
            const url = urls[0];
            const cleanUrl = removedDot(url);
            // 检查是否已有协议前缀（http:// 或 https://）
            const hasProtocol = /^https?:\/\//i.test(cleanUrl);
            const finalHref = hasProtocol ? cleanUrl : `http://${cleanUrl}`;

            this.productData.conditions = conditions.replace(
              url,
              `<a style="color: blue; text-decoration: underline;" href="${finalHref}" target="_BLANK">${cleanUrl}</a>`,
            );
          } else {
            this.productData.conditions = conditions;
          }
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use 'index';
</style>
<style lang="scss">
  .swiper-pagination-bullet-custom {
    display: inline-block;
    width: 14px;
    height: 14px;
    // margin-right: 4px;
    background: rgba(22, 48, 73, 0.5);
    border-radius: 100%;
    opacity: 1;

    // &:not(:last-child) {
    //   margin-right: 20px;
    // }
  }

  .swiper-pagination-bullet-active-custom {
    background: #163049;
    opacity: 1;
  }

  @media screen and (max-width: 1024px) {
    .swiper-pagination-bullet-custom {
      display: inline-block;
      width: 10px;
      height: 10px;
      // margin-right: 4px;
      background: rgba(22, 48, 73, 0.5);
      border-radius: 100%;
      opacity: 1;

      // &:not(:last-child) {
      //   margin-right: 16px;
      // }
    }
    .swiper-pagination-bullet-active-custom {
      background: #163049;
      opacity: 1;
    }
  }
</style>
